"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _framerMotion = require("framer-motion");

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette$backgr, _theme$palette, _theme$palette$backgr2, _theme$palette$backgr3, _root;

  return {
    root: (_root = {
      background: (_theme$palette$backgr = theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$backgr2 = _theme$palette.background) === null || _theme$palette$backgr2 === void 0 ? void 0 : (_theme$palette$backgr3 = _theme$palette$backgr2.menu01) === null || _theme$palette$backgr3 === void 0 ? void 0 : _theme$palette$backgr3.menuMobileBackdropLayer2) !== null && _theme$palette$backgr !== void 0 ? _theme$palette$backgr : "#E5E5E3",
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "auto",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2, 1.5),
      position: "fixed",
      right: 0,
      top: 0,
      width: "calc(100vw - ".concat(theme === null || theme === void 0 ? void 0 : theme.spacing(9), "px)"),
      zIndex: 10
    }, _defineProperty(_root, theme.breakpoints.up("sm"), {
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2, 5)
    }), _defineProperty(_root, theme.breakpoints.up("lg"), {
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(6),
      width: "calc(100vw - ".concat(theme === null || theme === void 0 ? void 0 : theme.spacing(100), "px)")
    }), _root),
    back: _defineProperty({
      alignItems: "center",
      alignSelf: "flex-start",
      cursor: "pointer",
      display: "flex",
      marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(3)
    }, theme.breakpoints.up("lg"), {
      marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(5)
    })
  };
});

var MobileSubContainer = function MobileSubContainer(props) {
  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var backIcon = props.backIcon,
      backLabel = props.backLabel,
      close = props.close,
      onCloseStart = props.onCloseStart;
  var css = useStyles();
  var animation = {
    hidden: {
      opacity: 0,
      x: "10vw",
      transition: {
        duration: 0.2
      }
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };

  var hideMenu = function hideMenu() {
    onCloseStart();
    setShow(false);
  };

  return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: hideMenu
  }, /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    className: (0, _clsx.default)("menu-01-mobile-subcontainer", css.root),
    initial: show ? "hidden" : "visible",
    animate: show ? "visible" : "hidden",
    variants: animation,
    transition: {
      type: "spring",
      bounce: 0
    },
    onAnimationComplete: function onAnimationComplete(definition) {
      if (definition === "hidden") {
        close();
      }
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: hideMenu,
    className: (0, _clsx.default)("menu-01-mobile-subcontainer__back", css.back)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: backIcon
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)("menu-01-mobile-subcontainer__label")
  }, backLabel)), props.children));
};

MobileSubContainer.propTypes = {
  backIcon: _propTypes.default.string,
  backLabel: _propTypes.default.string,
  close: _propTypes.default.func.isRequired,
  onCloseStart: _propTypes.default.func
};
var _default = MobileSubContainer;
exports.default = _default;